import type { Placement } from '@atlaskit/popper';

import { TagButtonUIVariant } from '../constants/TagButtonUIVariant.ts';

export const getPopupPlacementForTagVariant = (variant: TagButtonUIVariant): Placement =>
	variant === TagButtonUIVariant.iconOnly ? 'auto' : 'bottom-start';
